export const Language_List = [
  { name: "Arabic", code: "ar", sortName: "Arabic" },
  { name: "Arabic (Levantine)", code: "apc", sampleCode: "ar-LB", fallbackSamples:["ar"]},
  { name: "Armenian", code: "hy" },
  { name: "Awadhi", code: "awa" },
  { name: "Azerbaijani", code: "az" },
  { name: "Bashkir", code: "ba" },
  { name: "Basque", code: "eu" },
  { name: "Belarusian", code: "be" },
  { name: "Bengali", code: "bn" },
  { name: "Bhojpuri", code: "bh" },
  { name: "Bosnian", code: "bs" },
  { name: "Bulgarian", code: "bg" },
  { name: "Cantonese (Yue)", code: "yue" },
  { name: "Catalan", code: "ca" },
  { name: "Chhattisgarhi", code: "hne" },
  { name: "Chinese", code: "zh" },
  { name: "Croatian", code: "hr" },
  { name: "Czech", code: "cs" },
  { name: "Danish", code: "da" },
  { name: "Dogri", code: "doi" },
  { name: "Dutch", code: "nl" },
  { name: "English", code: "en" },
  { name: "Estonian", code: "et" },
  { name: "Faroese", code: "fo" },
  { name: "Filipino", code: "fil" },
  { name: "Finnish", code: "fi" },
  { name: "French", code: "fr" },
  { name: "Galician", code: "gl" },
  { name: "Georgian", code: "ka" },
  { name: "German", code: "de" },
  { name: "Greek", code: "el" },
  { name: "Gujarati", code: "gu" },
  { name: "Haryanvi", code: "hry" },
  { name: "Hebrew", code: "he" },
  { name: "Hindi", code: "hi" },
  { name: "Hungarian", code: "hu" },
  { name: "Icelandic", code: "is" },
  { name: "Indonesian", code: "id" },
  { name: "Irish", code: "ga" },
  { name: "Italian", code: "it" },
  { name: "Japanese", code: "ja" },
  { name: "Javanese", code: "jv" },
  { name: "Kannada", code: "kn" },
  { name: "Kashmiri", code: "ks" },
  { name: "Kazakh", code: "kk" },
  { name: "Konkani", code: "kok" },
  { name: "Korean", code: "ko" },
  { name: "Kyrgyz", code: "ky" },
  { name: "Latvian", code: "lv" },
  { name: "Lithuanian", code: "lt" },
  { name: "Macedonian", code: "mk" },
  { name: "Maithili", code: "mai" },
  { name: "Malay", code: "ms" },
  { name: "Maltese", code: "mt" },
  { name: "Mandarin Chinese", code: "cmn" },
  { name: "Marathi", code: "mr" },
  { name: "Marwari", code: "mwr" },
  { name: "Min Nan", code: "nan" },
  { name: "Moldovan", code: "mo" },
  { name: "Mongolian", code: "mn" },
  { name: "Montenegrin", code: "me" },
  { name: "Nepali", code: "ne" },
  { name: "Norwegian", code: "no" },
  { name: "Oriya", code: "or" },
  { name: "Pashto", code: "ps" },
  { name: "Persian (Farsi)", code: "fa" },
  { name: "Polish", code: "pl" },
  { name: "Portuguese", code: "pt", fallbackSamples:["pt-BR", "pt-PT"]},
  { name: "Portuguese (Brazil)", code: "pt-BR", fallbackSamples:["pt", "pt-PT"]},
  { name: "Portuguese (Portugal)", code: "pt-PT", fallbackSamples:["pt", "pt-BR"] },
  { name: "Punjabi", code: "pa" },
  { name: "Rajasthani", code: "raj" },
  { name: "Romanian", code: "ro" },
  { name: "Russian", code: "ru" },
  { name: "Sanskrit", code: "sa" },
  { name: "Santali", code: "sat" },
  { name: "Serbian", code: "sr" },
  { name: "Sindhi", code: "sd" },
  { name: "Sinhala", code: "si" },
  { name: "Slovak", code: "sk" },
  { name: "Slovene", code: "sl" },
  { name: "Spanish", code: "es" },
  { name: "Swahili", code: "sw" },
  { name: "Swedish", code: "sv" },
  { name: "Tagalog", code: "tl" },
  { name: "Tajik", code: "tg" },
  { name: "Tamil", code: "ta" },
  { name: "Tatar", code: "tt" },
  { name: "Telugu", code: "te" },
  { name: "Thai", code: "th" },
  { name: "Turkish", code: "tr" },
  { name: "Turkmen", code: "tk" },
  { name: "Ukrainian", code: "uk" },
  { name: "Urdu", code: "ur" },
  { name: "Uzbek", code: "uz" },
  { name: "Vietnamese", code: "vi" },
  { name: "Welsh", code: "cy" },
  { name: "Wu", code: "wuu" }
]
const CodeLookup = {}
for (const lang of Language_List) {
  CodeLookup[lang.code] = lang;
}

export const languageSortFunction = (a, b) => {
  console.log(a, b);
  const aLang = CodeLookup[a];
  const bLang = CodeLookup[b];
  return (aLang?.sortName ?? aLang.name).localeCompare(bLang?.sortName ?? bLang.name);
}

export const ELEVENLABS_LANGUAGES = ['en', 'he', 'es', 'fr', 'de', 'it', 'pt', 'pl', 'uk', 'ar', 'zh', 'ja', 'ko', 'hi',
  'nl', 'tr', 'sv', 'id', 'fil', 'ms', 'ro', 'vi', 'cs', 'el', 'bg', 'ru', 'sr', 'hr', 'fi', 'sk', 'da', 'ta', 'no']

export const ELEVENLABS_LANGUAGE_MAP = {}
for (const lang of ELEVENLABS_LANGUAGES) {
  ELEVENLABS_LANGUAGE_MAP[lang] = Language_List.find((l) => l.code === lang)?.name;
  if (!ELEVENLABS_LANGUAGE_MAP[lang]) {
    console.verbose(`Language ${lang} not found in Language_List`);
    delete ELEVENLABS_LANGUAGE_MAP[lang];
  }
}

export const getSampleLanguagePriority = (code) => {
   const entry = CodeLookup[code];
   const out = [entry?.sampleCode ?? code, ...(entry?.fallbackSamples || [])]
   out.push("en") // fallback to English
   return out;
}

export const CLOUD_TRANSLATE_LANGUAGES = ['ab', 'ace', 'ach', 'af', 'ak', 'alz', 'am', 'ar', 'as', 'awa', 'ay', 'az',
  'ba', 'ban', 'bbc', 'be', 'bem', 'bew', 'bg', 'bho', 'bik', 'bm', 'bn', 'br', 'bs', 'bts', 'btx', 'bua', 'ca', 'ceb',
  'cgg', 'chm', 'ckb', 'cnh', 'co', 'crh', 'crs', 'cs', 'cv', 'cy', 'da', 'de', 'din', 'doi', 'dov', 'dv', 'dz', 'ee',
  'el', 'en', 'eo', 'es', 'et', 'eu', 'fa', 'ff', 'fi', 'fj', 'fr', 'fr-CA', 'fy', 'ga', 'gaa', 'gd', 'gl', 'gn', 'gom',
  'gu', 'ha', 'haw', 'he', 'hi', 'hil', 'hmn', 'hr', 'hrx', 'ht', 'hu', 'hy', 'id', 'ig', 'ilo', 'is', 'it', 'iw', 'ja',
  'jv', 'jw', 'ka', 'kk', 'km', 'kn', 'ko', 'kri', 'ktu', 'ku', 'ky', 'la', 'lb', 'lg', 'li', 'lij', 'lmo', 'ln', 'lo',
  'lt', 'ltg', 'luo', 'lus', 'lv', 'mai', 'mak', 'mg', 'mi', 'min', 'mk', 'ml', 'mn', 'mni-Mtei', 'mr', 'ms', 'ms-Arab',
  'mt', 'my', 'ne', 'new', 'nl', 'no', 'nr', 'nso', 'nus', 'ny', 'oc', 'om', 'or', 'pa', 'pa-Arab', 'pag', 'pam', 'pap',
  'pl', 'ps', 'pt-BR', 'pt-PT', 'qu', 'rn', 'ro', 'rom', 'ru', 'rw', 'sa', 'scn', 'sd', 'sg', 'shn', 'si', 'sk', 'sl', 'sm',
  'sn', 'so', 'sq', 'sr', 'ss', 'st', 'su', 'sv', 'sw', 'szl', 'ta', 'te', 'tet', 'tg', 'th', 'ti', 'tk', 'tl', 'tn', 'tr',
  'ts', 'tt', 'ug', 'uk', 'ur', 'uz', 'vi', 'xh', 'yi', 'yo', 'yua', 'yue', 'zh', 'zh-CN', 'zh-TW', 'zu', 'apc'];


export const CLOUD_TRANSLATE_LANGUAGE_MAP = {}
for (const lang of CLOUD_TRANSLATE_LANGUAGES) {
  if (Language_List.find((l) => l.code === lang)) {
    CLOUD_TRANSLATE_LANGUAGE_MAP[lang] = Language_List.find((l) => l.code === lang)?.name;
  }
}

export const ANATOMY_EXPLORER_LANGUAGES = [
  'es', 'he', 'fr', 'de', 'it', 'pt', 'pl', 'uk', 'ar', 'zh', 'ja', 'ko', 'hi',
  'nl', 'tr', 'sv', 'id', 'fil', 'ms', 'ro', 'vi', 'cs', 'el', 'bg', 'ru', 'sr', 
  'hr', 'fi', 'sk', 'da', 'ta', 'no','bn', 'vi', 'ur', 'en'];

export const ANATOMY_EXPLORER_LANGUAGE_MAP = {}
for (const lang of ANATOMY_EXPLORER_LANGUAGES) {
  if (Language_List.find((l) => l.code === lang)) {
    ANATOMY_EXPLORER_LANGUAGE_MAP[lang] = Language_List.find((l) => l.code === lang)?.name;
  }
}

const getLanguageFromModel = (voice) => {
  const lang = {}
  for (const l of voice.verified_languages) {
    if (!lang[l.language]) {
      lang[l.language] = { model_id: l.model_id, sample: l.preview_url };
    }
    if (l.locale && !lang[l.locale]) {
      lang[l.locale] = { model_id: l.model_id, sample: l.preview_url };
    }
  }
  return lang;
};
let _voice_list_promise = null;
export const getVoiceList = () => {
  if (_voice_list_promise) {
    return _voice_list_promise;
  }
  _voice_list_promise = new Promise((resolve, reject) => {
    fetch('https://api.elevenlabs.io/v1/voices')
      .then(response => response.json())
      .then((data) => {
        const voices = data.voices.map(voice => {
          return {
            voice_id: voice.voice_id,
            name: voice.name,
            gender: voice.labels.gender,
            language: getLanguageFromModel(voice)
          };
        });
        voices.push({
          voice_id: SARA.voice_id,
          name: SARA.name,
          gender: SARA.labels.gender,
          language: getLanguageFromModel(SARA),
          allowedLanguages: ["ar", "apc"]
        }
        )
        resolve(voices);
      })
      .catch(error => {
        reject(error);
      });
  });
  return _voice_list_promise;
}

const SARA ={
   "voice_id": "gMB389pj77Qe5nErWNjd",
   "name": "Sara - Friendly, Professional and Clear",
   "samples": null,
   "category": "professional",
   "fine_tuning": {
      "is_allowed_to_fine_tune": true,
      "state": {
         "eleven_multilingual_sts_v2": "fine_tuned",
         "eleven_turbo_v2_5": "fine_tuned",
         "eleven_v4_exp": "fine_tuned",
         "eleven_v4_post_trained": "fine_tuned",
         "eleven_v4_turbo_exp": "fine_tuned",
         "eleven_flash_v2_5": "fine_tuned",
         "eleven_v4": "fine_tuned",
         "eleven_v4_turbo": "fine_tuned",
         "eleven_v4_hq": "fine_tuned",
         "eleven_v4_eval": "fine_tuned",
         "eleven_v2_5_flash": "fine_tuned",
         "eleven_multilingual_v2": "fine_tuned"
      },
      "verification_failures": [],
      "verification_attempts_count": 0,
      "manual_verification_requested": false,
      "language": "ar",
      "progress": {},
      "message": {
         "eleven_multilingual_sts_v2": "",
         "eleven_turbo_v2_5": "",
         "eleven_v4_exp": "",
         "eleven_v4_post_trained": "",
         "eleven_v4_turbo_exp": "",
         "eleven_flash_v2_5": "",
         "eleven_v4": "",
         "eleven_v4_turbo": "",
         "eleven_v4_hq": "",
         "eleven_v4_eval": "",
         "eleven_v2_5_flash": "",
         "eleven_multilingual_v2": ""
      },
      "dataset_duration_seconds": null,
      "verification_attempts": null,
      "slice_ids": null,
      "manual_verification": null,
      "max_verification_attempts": 0,
      "next_max_verification_attempts_reset_unix_ms": 0
   },
   "labels": {
      "language": "ar",
      "accent": "modern standard",
      "age": "middle_aged",
      "use_case": "informative_educational",
      "gender": "female",
      "descriptive": "calm"
   },
   "description": "Friendly and professional female voice.",
   "preview_url": "https://api.us.elevenlabs.io/v1/voices/gMB389pj77Qe5nErWNjd/previews/audio?payload=eyJ2b2ljZV9zb3VyY2UiOiJjdXN0b20iLCJ3b3Jrc3BhY2VfaWQiOiI4YWM4NTNlMjdkNmQ0MTBiYjI4MzdlZmE2MGI0MmM2MyIsImZpbGVuYW1lIjoiZ2dMcDBRZ3NucU13MTdna1FKMWsubXAzIiwidGltZXN0YW1wIjoxNzkzMDUyMDAwMDAwMDAwfQ%3D%3D",
   "available_for_tiers": [],
   "settings": null,
   "sharing": {
      "status": "copied",
      "history_item_sample_id": null,
      "date_unix": 1793054068,
      "whitelisted_emails": [],
      "public_owner_id": "0f88c3e95f5c0d7e60f3632395d18e4549ad7e7a5196a7d230629f7a0ecd1277",
      "original_voice_id": "gMB389pj77Qe5nErWNjd",
      "financial_rewards_enabled": false,
      "free_users_allowed": true,
      "live_moderation_enabled": false,
      "rate": 1.0,
      "fiat_rate": null,
      "notice_period": 730,
      "disable_at_unix": null,
      "voice_mixing_allowed": false,
      "featured": false,
      "category": "professional",
      "reader_app_enabled": null,
      "image_url": "",
      "ban_reason": null,
      "liked_by_count": 0,
      "cloned_by_count": 0,
      "name": "Sara - Friendly, Professional and Clear",
      "description": "Friendly and professional female voice.",
      "labels": {
         "language": "ar",
         "accent": "modern standard",
         "gender": "female",
         "use_case": "informative_educational",
         "age": "middle_aged",
         "descriptive": "calm",
         "locale": "ar-SA"
      },
      "review_status": "not_requested",
      "review_message": null,
      "enabled_in_library": false,
      "instagram_username": null,
      "twitter_username": null,
      "youtube_username": null,
      "tiktok_username": null,
      "moderation_check": null,
      "reader_restricted_on": null
   },
   "high_quality_base_model_ids": [
      "eleven_multilingual_v2",
      "eleven_turbo_v2_5",
      "eleven_flash_v2_5",
      "eleven_multilingual_sts_v2",
      "eleven_v4",
      "eleven_v4_hq",
      "eleven_v4_post_trained",
      "eleven_v4_turbo"
   ],
   "verified_languages": [
      {
         "language": "ar",
         "model_id": "eleven_multilingual_v2",
         "accent": "modern standard",
         "locale": "ar-SA",
         "preview_url": "https://api.us.elevenlabs.io/v1/voices/gMB389pj77Qe5nErWNjd/previews/audio?payload=eyJ2b2ljZV9zb3VyY2UiOiJjdXN0b20iLCJ3b3Jrc3BhY2VfaWQiOiI4YWM4NTNlMjdkNmQ0MTBiYjI4MzdlZmE2MGI0MmM2MyIsImZpbGVuYW1lIjoiZ2dMcDBRZ3NucU13MTdna1FKMWsubXAzIiwidGltZXN0YW1wIjoxNzkzMDUyMDAwMDAwMDAwfQ%3D%3D"
      },
      {
         "language": "ar",
         "model_id": "eleven_turbo_v2_5",
         "accent": "modern standard",
         "locale": "ar-SA",
         "preview_url": "https://api.us.elevenlabs.io/v1/voices/gMB389pj77Qe5nErWNjd/previews/audio?payload=eyJ2b2ljZV9zb3VyY2UiOiJjdXN0b20iLCJ3b3Jrc3BhY2VfaWQiOiI4YWM4NTNlMjdkNmQ0MTBiYjI4MzdlZmE2MGI0MmM2MyIsImZpbGVuYW1lIjoiZ2dMcDBRZ3NucU13MTdna1FKMWsubXAzIiwidGltZXN0YW1wIjoxNzkzMDUyMDAwMDAwMDAwfQ%3D%3D"
      },
      {
         "language": "ar",
         "model_id": "eleven_v2_5_flash",
         "accent": "modern standard",
         "locale": "ar-SA",
         "preview_url": "https://api.us.elevenlabs.io/v1/voices/gMB389pj77Qe5nErWNjd/previews/audio?payload=eyJ2b2ljZV9zb3VyY2UiOiJjdXN0b20iLCJ3b3Jrc3BhY2VfaWQiOiI4YWM4NTNlMjdkNmQ0MTBiYjI4MzdlZmE2MGI0MmM2MyIsImZpbGVuYW1lIjoiZ2dMcDBRZ3NucU13MTdna1FKMWsubXAzIiwidGltZXN0YW1wIjoxNzkzMDUyMDAwMDAwMDAwfQ%3D%3D"
      },
      {
         "language": "ar",
         "model_id": "eleven_flash_v2_5",
         "accent": "modern standard",
         "locale": "ar-SA",
         "preview_url": "https://api.us.elevenlabs.io/v1/voices/gMB389pj77Qe5nErWNjd/previews/audio?payload=eyJ2b2ljZV9zb3VyY2UiOiJjdXN0b20iLCJ3b3Jrc3BhY2VfaWQiOiI4YWM4NTNlMjdkNmQ0MTBiYjI4MzdlZmE2MGI0MmM2MyIsImZpbGVuYW1lIjoiZ2dMcDBRZ3NucU13MTdna1FKMWsubXAzIiwidGltZXN0YW1wIjoxNzkzMDUyMDAwMDAwMDAwfQ%3D%3D"
      },
      {
         "language": "ar",
         "model_id": "eleven_multilingual_sts_v2",
         "accent": "modern standard",
         "locale": "ar-SA",
         "preview_url": "https://api.us.elevenlabs.io/v1/voices/gMB389pj77Qe5nErWNjd/previews/audio?payload=eyJ2b2ljZV9zb3VyY2UiOiJjdXN0b20iLCJ3b3Jrc3BhY2VfaWQiOiI4YWM4NTNlMjdkNmQ0MTBiYjI4MzdlZmE2MGI0MmM2MyIsImZpbGVuYW1lIjoiZ2dMcDBRZ3NucU13MTdna1FKMWsubXAzIiwidGltZXN0YW1wIjoxNzkzMDUyMDAwMDAwMDAwfQ%3D%3D"
      },
      {
         "language": "ar",
         "model_id": "eleven_v4",
         "accent": "modern standard",
         "locale": "ar-SA",
         "preview_url": "https://api.us.elevenlabs.io/v1/voices/gMB389pj77Qe5nErWNjd/previews/audio?payload=eyJ2b2ljZV9zb3VyY2UiOiJjdXN0b20iLCJ3b3Jrc3BhY2VfaWQiOiI4YWM4NTNlMjdkNmQ0MTBiYjI4MzdlZmE2MGI0MmM2MyIsImZpbGVuYW1lIjoiZ2dMcDBRZ3NucU13MTdna1FKMWsubXAzIiwidGltZXN0YW1wIjoxNzkzMDUyMDAwMDAwMDAwfQ%3D%3D"
      },
      {
         "language": "ar",
         "model_id": "eleven_v4_eval",
         "accent": "modern standard",
         "locale": "ar-SA",
         "preview_url": "https://api.us.elevenlabs.io/v1/voices/gMB389pj77Qe5nErWNjd/previews/audio?payload=eyJ2b2ljZV9zb3VyY2UiOiJjdXN0b20iLCJ3b3Jrc3BhY2VfaWQiOiI4YWM4NTNlMjdkNmQ0MTBiYjI4MzdlZmE2MGI0MmM2MyIsImZpbGVuYW1lIjoiZ2dMcDBRZ3NucU13MTdna1FKMWsubXAzIiwidGltZXN0YW1wIjoxNzkzMDUyMDAwMDAwMDAwfQ%3D%3D"
      },
      {
         "language": "ar",
         "model_id": "eleven_v4_exp",
         "accent": "modern standard",
         "locale": "ar-SA",
         "preview_url": "https://api.us.elevenlabs.io/v1/voices/gMB389pj77Qe5nErWNjd/previews/audio?payload=eyJ2b2ljZV9zb3VyY2UiOiJjdXN0b20iLCJ3b3Jrc3BhY2VfaWQiOiI4YWM4NTNlMjdkNmQ0MTBiYjI4MzdlZmE2MGI0MmM2MyIsImZpbGVuYW1lIjoiZ2dMcDBRZ3NucU13MTdna1FKMWsubXAzIiwidGltZXN0YW1wIjoxNzkzMDUyMDAwMDAwMDAwfQ%3D%3D"
      },
      {
         "language": "ar",
         "model_id": "eleven_v4_hq",
         "accent": "modern standard",
         "locale": "ar-SA",
         "preview_url": "https://api.us.elevenlabs.io/v1/voices/gMB389pj77Qe5nErWNjd/previews/audio?payload=eyJ2b2ljZV9zb3VyY2UiOiJjdXN0b20iLCJ3b3Jrc3BhY2VfaWQiOiI4YWM4NTNlMjdkNmQ0MTBiYjI4MzdlZmE2MGI0MmM2MyIsImZpbGVuYW1lIjoiZ2dMcDBRZ3NucU13MTdna1FKMWsubXAzIiwidGltZXN0YW1wIjoxNzkzMDUyMDAwMDAwMDAwfQ%3D%3D"
      },
      {
         "language": "ar",
         "model_id": "eleven_v4_post_trained",
         "accent": "modern standard",
         "locale": "ar-SA",
         "preview_url": "https://api.us.elevenlabs.io/v1/voices/gMB389pj77Qe5nErWNjd/previews/audio?payload=eyJ2b2ljZV9zb3VyY2UiOiJjdXN0b20iLCJ3b3Jrc3BhY2VfaWQiOiI4YWM4NTNlMjdkNmQ0MTBiYjI4MzdlZmE2MGI0MmM2MyIsImZpbGVuYW1lIjoiZ2dMcDBRZ3NucU13MTdna1FKMWsubXAzIiwidGltZXN0YW1wIjoxNzkzMDUyMDAwMDAwMDAwfQ%3D%3D"
      },
      {
         "language": "ar",
         "model_id": "eleven_v4_turbo",
         "accent": "modern standard",
         "locale": "ar-SA",
         "preview_url": "https://api.us.elevenlabs.io/v1/voices/gMB389pj77Qe5nErWNjd/previews/audio?payload=eyJ2b2ljZV9zb3VyY2UiOiJjdXN0b20iLCJ3b3Jrc3BhY2VfaWQiOiI4YWM4NTNlMjdkNmQ0MTBiYjI4MzdlZmE2MGI0MmM2MyIsImZpbGVuYW1lIjoiZ2dMcDBRZ3NucU13MTdna1FKMWsubXAzIiwidGltZXN0YW1wIjoxNzkzMDUyMDAwMDAwMDAwfQ%3D%3D"
      },
      {
         "language": "ar",
         "model_id": "eleven_v4_turbo_exp",
         "accent": "modern standard",
         "locale": "ar-SA",
         "preview_url": "https://api.us.elevenlabs.io/v1/voices/gMB389pj77Qe5nErWNjd/previews/audio?payload=eyJ2b2ljZV9zb3VyY2UiOiJjdXN0b20iLCJ3b3Jrc3BhY2VfaWQiOiI4YWM4NTNlMjdkNmQ0MTBiYjI4MzdlZmE2MGI0MmM2MyIsImZpbGVuYW1lIjoiZ2dMcDBRZ3NucU13MTdna1FKMWsubXAzIiwidGltZXN0YW1wIjoxNzkzMDUyMDAwMDAwMDAwfQ%3D%3D"
      }
   ],
   "collection_ids": [],
   "safety_control": null,
   "voice_verification": {
      "requires_verification": false,
      "is_verified": false,
      "verification_failures": [],
      "verification_attempts_count": 0,
      "language": null,
      "verification_attempts": null
   },
   "permission_on_resource": "admin",
   "is_owner": false,
   "is_legacy": false,
   "is_mixed": false,
   "favorited_at_unix": null,
   "created_at_unix": 1793054068,
   "is_bookmarked": true,
   "recording_quality": null,
   "labelling_status": null,
   "recording_quality_reason": null
}